import ScheduleViewVisits from "./Visits";

export default class ScheduleViewSlots extends ScheduleViewVisits {

    openShift(info, shiftIdDate, event) {
        const { dateMode, date } = info;

        if (date.setHours(23, 59) <= new Date().setHours(0, 0))
            return false;

        if (dateMode === "week") {
            const { offsetHeight } = this.doctorsNodes[shiftIdDate];
            const clickY = event.nativeEvent.offsetY;

            if (clickY < offsetHeight / 2) {
                info.start = "08:00";
                info.end = "15:00";
            } else {
                info.start = "15:00";
                info.end = "22:00";
            }

        }

        if (this.props.openShift?.apply)
            this.props.openShift({ ...info }, this.props.refreshVisits);
    }

    insertSlot(info, index) {
        const { shiftItemId, from, size, data } = info;
        info.color = index % 2 === 0 ? "blue" : "green";

        const shiftIdDate = `${shiftItemId}_${size}_${from}_${index}`;
        const { editDoctorsMode } = this.props.info;
        const editCl = editDoctorsMode ? "editMode" : "";

        return (
            <div
                key={shiftIdDate}
                ref={el => this.doctorsNodes[shiftIdDate] = el}
                className={`doctor pos abs rad8 ${editCl}`}
                style={{ "--from": from, "--size": size }}
                data-id={shiftItemId}
                data-id-date={shiftIdDate}
                onClick={this.openShift.bind(this, info, shiftIdDate)}
            >
                {data && data.map((it, i) => this.insertVisit({ ...info, ...it }, i))}
            </div>
        );
    }
}
